import React from "react";
export default function LoginHeader(){
    var logo = require(`../assets/images/${process.env.REACT_APP_ENV}/logo.png`)

    return (
        <>
            <img className="w-25 h-100" src={logo} />
            <h5 className="justify-content-center align-items-center d-flex text-light pt-2 iranSansBold mb-5">پنل درخواست {process.env.REACT_APP_CO_NAME}</h5>
        </>
    )
}